export default function authMiddleware({ next, router }) {
    const canRedirect = !(router.name == 'auth.signin')
    const accessToken = this.$cookies.get('access_token')
    
    if (!accessToken && canRedirect) {
        router.push({name: 'auth.signin'})
    }

    return next();
  }